import SelfPayTab from "../../../../patient/details/selfpay/SelfPayTab";

export default function SelfPayDrawerTab({classes, goToCaseTabHandler, column = 5, inWorkQ}) {
    return <div className={`${classes.block} ${classes[`block_${column}`]}`}>
        <SelfPayTab inWorkQ={inWorkQ} />
    </div>
}
